export enum ContentTypeEnum {
    Posting = 0,
    Article = 1,
    Course = 2,
    Category = 3,
    Live_Link = 4,
}
